module.exports = __webpack_public_path__ + "img/logo.f7f04369.png";